import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=d465f7a0&scoped=true&"
import script from "./ReportDetails.vue?vue&type=script&lang=ts&"
export * from "./ReportDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=d465f7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d465f7a0",
  null
  
)

export default component.exports